const jsonToObject = <T, K>(json: string, failureReturnValue: K, onError: (error: any) => void): T | K => {
    try {
        return JSON.parse(json);
    } catch (error: any) {
        onError(error);
        return failureReturnValue;
    }
};

export default jsonToObject;
